import axios from "axios";
import $store from "../store";
 import store from "@utils/store/cookie";
import toLogin from "@libs/login";
import { VUE_APP_API_URL } from "@utils/index";

 
 
axios.defaults.headers.post['Content-Type'] = 'application/json';
//axios.defaults.headers.post['X-Requested-With'] = 'XMLHttpRequest';
const instance = axios.create({
  baseURL: VUE_APP_API_URL,
  withCredentials: true,
  timeout: 50000
});

const defaultOpt = { login: true };

function baseRequest(options) {
	
	 
			const userInfo = localStorage.getItem('userInfo'); 
			 
			  const uid = 'fxy';
			 if (userInfo === null) {
    console.log('该项不存在');
	
	
	
} else {
   const user = JSON.parse(userInfo);
		const uid =  user.uid;
}


		 
		console.log(uid);
	// const uid=store.get("uid") || null;
 //const uid= $store.state.uid || null;
  const headers = options.headers || {};
  headers["Authori-zation"] = "Bearer " + uid;
  headers['Content-Type'] = 'application/json';
  options.headers = headers;
 // if (options.login ) {
   // toLogin();
  //  return Promise.reject({ msg: "未登录", toLogin: true });
 // }
  console.log(options);
  return instance(options).then(res => {
    const data = res.data || {};
 
    if (res.status !== 200)
      return Promise.reject({ msg: "请求失败", res, data });

    if ([410000, 410001, 410002].indexOf(data.status) !== -1) {
      toLogin();
      return Promise.reject({ msg: data.msg, res, data, toLogin: true });
    } else if (res.status === 200) { 
   
      return Promise.resolve(data, res);
    } else {
      return Promise.reject({ msg: data.msg, res, data });
    }
  });
}

/**
 * http 请求基础类
 * 参考文档 https://www.kancloud.cn/yunye/axios/234845
 *
 */
const request = ["post", "put", "patch"].reduce((request, method) => {
  /**
   *
   * @param url string 接口地址
   * @param data object get参数
   * @param options object axios 配置项
   * @returns {AxiosPromise}
   */
  request[method] = (url, data = {}, options = {}) => {
    return baseRequest(
      Object.assign({ url, data, method }, defaultOpt, options)
    );
  };
  return request;
}, {});

["get", "delete", "head"].forEach(method => {
  /**
   *
   * @param url string 接口地址
   * @param params object get参数
   * @param options object axios 配置项
   * @returns {AxiosPromise}
   */
  request[method] = (url, params = {}, options = {}) => {
    return baseRequest(
      Object.assign({ url, params, method }, defaultOpt, options)
    );
  };
});

export default request;
